<template>
	<div>
		<v-data-table disable-initial-sort :headers="headers" :items="performanceReviewItems" hide-actions class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr>
					<td class="text-xs-left" style="width: 1px;">
						<v-chip v-if="props.item.isCondensed" outline small :color="getTypeChipColor(props.item.type)"><v-icon class="mr-1">mdi-collapse-all-outline</v-icon>Condensed {{ getTypeFriendly(props.item.type) }}</v-chip>
						<v-chip v-else small :color="getTypeChipColor(props.item.type)" text-color="white">{{ getTypeFriendly(props.item.type) }}</v-chip>
					</td>
					
					<td class="text-xs-left">{{ props.item.item }}</td>
					<td v-if="showCategory" class="text-xs-left">{{ props.item.category === "N/A" ? "" : props.item.category }}</td>
					<td class="justify-center px-0">
						<v-icon small class="mr-2" @click="editItem(props.item)">
							edit
						</v-icon>
						<v-icon small @click="deleteItem(props.item)">
							delete
						</v-icon>
					</td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>
	import typeFriendlyMixin from '@/mixins/typeFriendlyMixin';

	export default {
		props: {
			performanceReviewItems: {
				required: true,
				type: Array
			},
			showCategory: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				editedItem: undefined,
				editedItemIndex: -1
			};
		},
		mixins: [typeFriendlyMixin],
		computed: {
			headers() {
				const headers = [
					{ text: 'Type', value: 'type' },			
					{ text: 'Discussion Point', value: 'item' },
					{ text: '', value: 'actions', sortable: false }
				];

				if (this.showCategory) {
					headers.splice(2, 0, { text: 'Category', value: 'category' });
				}

				return headers;
			}
		},
		methods: {
			save(item) {
				if (this.editedItemIndex > -1) {
					Object.assign(this.performanceReviewItems[this.editedItemIndex], item);
				} else {
					this.performanceReviewItems.push(item);
				}

				this.dialog = !this.dialog;
			},
			editItem(item) {
				this.$emit('onEditItem', item);
			},
			deleteItem(item) {
				this.$emit('onDeleteItem', item);
			}
		}
	};
</script>

<style></style>
